// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2KJoI","messages":"Chat_messages__1HZle","dateDivider":"Chat_dateDivider__14j4G"};